// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.game {
    height: 100%;
    width: 75%;
    display: flex;
    justify-content: space-around;
    align-items: stretch;
}

.rows {
    align-self: center;
    flex-grow: 1;
}

.words {
    margin: 75px 50px;
    flex-grow: 1;
    overflow-y: scroll;
    outline: dotted #312a2c 5px;
    border-radius: 15px;
    background-color: #615358;
}


.words::-webkit-scrollbar {
    width: 10px;
    border-radius: 5px;
}
.words::-webkit-scrollbar-track {
    background: #312a2c;
}
.words::-webkit-scrollbar-thumb {
    background: #3aa394;
    border-radius: 5px;
}

.words p {
    font-family: "PT Mono";
    font-size: 15px;
    color: white;
    text-align: center;
    width: 100%;
    margin: 10px 0;
}

.words p:first-of-type {
    font-size: 20px;
    position: sticky;
    top: 0;
    margin: 0;
    padding: 20px 0;
    background-color: #615358;
}

.words p:nth-of-type(2) {
    margin-top: 0;
}

.game img {
    position: absolute;
    top: 15px;
    left: 15px;
    width: 30px;
}`, "",{"version":3,"sources":["webpack://./src/style/Game.css"],"names":[],"mappings":"AAAA;IACI,YAAY;IACZ,UAAU;IACV,aAAa;IACb,6BAA6B;IAC7B,oBAAoB;AACxB;;AAEA;IACI,kBAAkB;IAClB,YAAY;AAChB;;AAEA;IACI,iBAAiB;IACjB,YAAY;IACZ,kBAAkB;IAClB,2BAA2B;IAC3B,mBAAmB;IACnB,yBAAyB;AAC7B;;;AAGA;IACI,WAAW;IACX,kBAAkB;AACtB;AACA;IACI,mBAAmB;AACvB;AACA;IACI,mBAAmB;IACnB,kBAAkB;AACtB;;AAEA;IACI,sBAAsB;IACtB,eAAe;IACf,YAAY;IACZ,kBAAkB;IAClB,WAAW;IACX,cAAc;AAClB;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,MAAM;IACN,SAAS;IACT,eAAe;IACf,yBAAyB;AAC7B;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,kBAAkB;IAClB,SAAS;IACT,UAAU;IACV,WAAW;AACf","sourcesContent":[".game {\n    height: 100%;\n    width: 75%;\n    display: flex;\n    justify-content: space-around;\n    align-items: stretch;\n}\n\n.rows {\n    align-self: center;\n    flex-grow: 1;\n}\n\n.words {\n    margin: 75px 50px;\n    flex-grow: 1;\n    overflow-y: scroll;\n    outline: dotted #312a2c 5px;\n    border-radius: 15px;\n    background-color: #615358;\n}\n\n\n.words::-webkit-scrollbar {\n    width: 10px;\n    border-radius: 5px;\n}\n.words::-webkit-scrollbar-track {\n    background: #312a2c;\n}\n.words::-webkit-scrollbar-thumb {\n    background: #3aa394;\n    border-radius: 5px;\n}\n\n.words p {\n    font-family: \"PT Mono\";\n    font-size: 15px;\n    color: white;\n    text-align: center;\n    width: 100%;\n    margin: 10px 0;\n}\n\n.words p:first-of-type {\n    font-size: 20px;\n    position: sticky;\n    top: 0;\n    margin: 0;\n    padding: 20px 0;\n    background-color: #615358;\n}\n\n.words p:nth-of-type(2) {\n    margin-top: 0;\n}\n\n.game img {\n    position: absolute;\n    top: 15px;\n    left: 15px;\n    width: 30px;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
